export default __webpack_public_path__ + "static/media/480_dummy2016-apotheke01-mobile-de.c4dbf9f0.png";